import { supabase } from './supabase';

export const competitionService = {
  async getAllCompetitions() {
    // First get all competitions (excluding deleted ones)
    const { data: competitions, error: competitionsError } = await supabase
      .from('competitions')
      .select('*')
      .neq('status', 'deleted')
      .order('created_at', { ascending: false });
    
    if (competitionsError) throw competitionsError;

    // For each competition, get its latest config
    const competitionsWithConfigs = await Promise.all(
      competitions.map(async (competition) => {
        const { data: config } = await supabase
          .from('competition_configs')
          .select('content, revision')
          .match({ competition_id: competition.id })
          .order('revision', { ascending: false })
          .limit(1)
          .single();

        return {
          competition: config?.content?.competition || competition,
          ...config?.content
        };
      })
    );
    
    return competitionsWithConfigs;
  },

  async getCompetition(id) {
    // Get the competition base data
    const { data: competition, error: competitionError } = await supabase
      .from('competitions')
      .select('*')
      .eq('id', id)
      .single();
    
    if (competitionError) throw competitionError;

    // Get its latest config
    const { data: config } = await supabase
      .from('competition_configs')
      .select('content, revision')
      .match({ competition_id: id })
      .order('revision', { ascending: false })
      .limit(1)
      .single();

    return {
      competition: config?.content?.competition || competition,
      ...config?.content
    };
  }
};
